export default "__VITE_ASSET__CmsCOvK8__"